import * as TogglePrimitive from '@radix-ui/react-toggle';
import React from 'react';
import { tv } from 'tailwind-variants';
const circle = tv({
    base: [
        // Transition
        'duration-300',
        'ease-smooth',
        'transition-combined',
        'will-change-transform',
        'bg-white',
        'shadow-sm',
        'rounded-full',
        'w-4',
        'h-4',
    ],
});
const root = tv({
    base: [
        'py-0',
        'cursor-pointer',
        'appearance-none',
        'rounded-full',
        'box-border',
        'duration-300',
        'ease-smooth',
        'transition-combined',
        'disabled:cursor-not-allowed',
        'border-none',
        'outline-none',
        // Size
        'px-1',
        'h-6',
        'w-10',
        // Focus state
        'focus-visible:outline-[3px]',
        'focus-visible:outline-gray-200',
        // Off
        'data-[state=off]:bg-gray-300',
        'data-[state=off]:bg-gray-300/50',
        '[&>div]:active:scale-x-110',
        '[&>div]:data-[state=off]:origin-left',
        // On
        '[&>div]:data-[state=on]:active:scale-x-110',
        '[&>div]:data-[state=on]:active:translate-x-full',
        '[&>div]:data-[state=on]:origin-right',
        '[&>div]:data-[state=on]:translate-x-full',
    ],
    variants: {
        variant: {
            primary: ['data-[state=on]:bg-gray-900'],
            legacyBlue: ['data-[state=on]:bg-legacyBlue'],
        },
        size: {},
        width: {},
    },
    defaultVariants: {
        variant: 'primary',
    },
});
function BtwToggle(props) {
    const { className, variant } = props;
    return (React.createElement(TogglePrimitive.Root, Object.assign({ className: root({ className, variant }) }, props),
        React.createElement("div", { className: circle() })));
}
export { BtwToggle };
